import React, { useState } from "react";
import data from "../../helper/data";
import "./Main.css";
import swal from "sweetalert";

const Main = () => {
  // let start = 0;

  const [start, setStart] = useState(0);
  const [descr, setDescr] = useState("");

  const asd = (e) => {
    console.log(e.target.id);
    let index = Number(e.target.id) - 1;
    console.log(data[index].desc);
    let abc = data[index].desc;
    setDescr(abc);
    swal(data[index].name, abc);
  };

  return (
    <div className="container">
      <div className="header">
        <div className="leftImg">
          <img
            src="https://i.giphy.com/media/DIsRunIvAO70z57QGl/giphy.webp"
            alt=""
          />
        </div>
        <h3>Legendary FB's Footballers</h3>

        <div className="rightImg">
          <img
            src="https://i.giphy.com/media/DIsRunIvAO70z57QGl/giphy.webp"
            alt=""
          />
        </div>
      </div>
      <div className="container-main">
        {data.slice(start, start + 4).map((item) => {
          return (
            <div className="main" onClick={(e) => asd(e)}>
              <div className="image-div">
                <img className="image" src={item.image} alt="" />
              </div>
              <div className="text">
                <h3>{item.name}</h3>
                <h6>{item.stats}</h6>
                <p className="description"></p>
                <button className="button" id={item.id}>
                  Info
                </button>
              </div>
            </div>
          );
        })}
        <p className="display">
          Footballer: {start + 1} to {start + 4}
        </p>
      </div>
      <div className="buttons">
        <button
          className="button"
          onClick={() => {
            start <= 0
              ? setStart(start + data.length - 4)
              : setStart(start - 4);
          }}>
          Previous
        </button>
        <button
          className="button"
          onClick={() => {
            start >= data.length - 4 ? setStart(0) : setStart(start + 4);
          }}>
          Next
        </button>
      </div>
    </div>
  );
};

export default Main;
